'use server';

import { getPaginatedPosts } from '@/lib/posts';

export async function fetchPosts(page: number, limit: number = 18) {
  const data = await getPaginatedPosts(page, limit);
  return data.posts;
}
